import {useEffect, useRef, useState} from "react";
import {Button, Card, Form, Input, Select} from "antd";
import {t} from "i18next";
import UnitSelectbox from "../unit/UnitSelectbox";
import {useHistory, useParams} from "react-router-dom";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";
import FirmSelectList from "../firm/FirmSelectList";

export default function CashRegisterCreateEdit({})
{
    const {cashRegisterId} = useParams();

    const formRef = useRef();
    const history = useHistory();
    const [cashRegister, setCashRegister] = useState({});

    const getCashRegister = async () => {
        if(cashRegisterId)
        {
            const res = await ApiService.CashRegister.GetCashRegister(cashRegisterId);

            if(res.success)
            {
                formRef.current.setFieldsValue({
                    ...res.data,
                });
                setCashRegister(res.data)
            }
        }
    }

    const onFinish = async (formData) => {
        if(cashRegisterId)
        {
            const res = await ApiService.CashRegister.EditCashRegister(cashRegisterId, formData);
            await getCashRegister();
        }
        else
        {
            const res = await ApiService.CashRegister.CreateCashRegister(formData);

            if(res.success)
            {
                history.push(`/app/system/cash-registers/${res.data}/edit`)
            }
        }
    }

    useEffect(() => {
        getCashRegister()
    }, [cashRegisterId])

    return (
        <SimpleLayout>
            <Card
                title={!cashRegisterId ? t('New Cash Register') : `${t('Edit Cash Register')} - ${cashRegister?.name}`}
            >
                <Form
                    size={'small'}
                    ref={formRef}
                    layout={'vertical'}
                    onFinish={onFinish}
                >
                    <Form.Item
                        label={t('Name')}
                        name={'name'}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label={t('Firm')}
                        name={'firmId'}
                    >
                        <FirmSelectList
                            style={{width: 200}}
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button htmlType={'submit'} type={'primary'}>{t('Save')}</Button>
                    </Form.Item>
                </Form>
            </Card>
        </SimpleLayout>
    )
}